import type { AdminBlastDoc } from '@bb/domain/dist/schemas';
import axios from 'axios';

export const getAnnouncement = async (
  announcementId: string,
): Promise<AdminBlastDoc> => {
  const { data } = await axios.get(`/announcement/${announcementId}`);
  return data;
};
